import {ManagePlanPageInfo, StepperReturnState, UIFeatureFlag} from '@ox/typings';
import {OX_KEYS} from '@ox/config';
import {Store} from '@ngrx/store';
import {selectFeatureFlag} from '@ox/data';
import {takeWhile, tap} from 'rxjs';

const ReturnStates: {[key: string]: StepperReturnState} = {
  MyPlans: {
    name: 'oc.main.onstar.dashboard',
    text: 'my_plans_link'
  }
};

export class ManagePlanPageSettings {
  isCheckoutRedesignEnabled: boolean;
  constructor(private store: Store){
    this.store
    .select(selectFeatureFlag({id: UIFeatureFlag.CHECKOUT, group: 'UI'}))
    .pipe(
      takeWhile((val) => !val, true) 
    ).subscribe((flag)=>{
      this.isCheckoutRedesignEnabled = flag === 'true';
      this.updateFlow();
    });
  }

  private updateFlow() {
    if (this.isCheckoutRedesignEnabled) {
      this.MANAGE.flow = this.MANAGE.flow.filter(key => key !== OX_KEYS.MY_PLANS.REVIEW_KEY);
    }
  }

  MANAGE: ManagePlanPageInfo = {
    flow: [
      OX_KEYS.MY_PLANS.MANAGE_KEY,
      OX_KEYS.MY_PLANS.REVIEW_KEY,
      OX_KEYS.MY_PLANS.CHECKOUT_KEY
    ],
    stepper: {
      stepInfo: {
        title: 'stepper_step_update',
        label: 'configureStep_label',
        state: 'oc.main.updatePlan'
      },
      returnState: ReturnStates['MyPlans']
    }
  };

  REVIEW: ManagePlanPageInfo = {
    flow: [OX_KEYS.MY_PLANS.REVIEW_KEY, OX_KEYS.MY_PLANS.CHECKOUT_KEY],
    stepper: {
      stepInfo: {
        title: 'stepper_step_review',
        label: 'reviewStep_label',
        state: 'oc.main.review'
      },
      returnState: ReturnStates['MyPlans']
    }
  };

  CHECKOUT: ManagePlanPageInfo = {
    flow: [OX_KEYS.MY_PLANS.REVIEW_KEY, OX_KEYS.MY_PLANS.CHECKOUT_KEY],
    stepper: {
      stepInfo: {
        title: 'stepper_step_checkout',
        label: 'checkoutStep_label'
      },
      returnState: ReturnStates['MyPlans']
    }
  };

  getPageType(pageType: string) {
    switch (pageType) {
      case OX_KEYS.MY_PLANS.REVIEW_KEY:
        return this.REVIEW;
      case OX_KEYS.MY_PLANS.CHECKOUT_KEY:
        return this.CHECKOUT;
      case OX_KEYS.MY_PLANS.MANAGE_KEY:
        return this.MANAGE;
    }
    return this.MANAGE;
  }
}
